import React from "react";
import { Navigate } from "react-router-dom";
import { UserLevel, UserLevelMeta } from "common/userLevels";

// ─── Token / session helpers ─────────────────────────────────────────────────

export function isLoggedIn() {
  return !!localStorage.getItem("token");
}
export function setLoggedIn(token) {
  localStorage.setItem("token", token);
}
export function getToken() {
  return localStorage.getItem("token");
}
export function getUserId() {
  return localStorage.getItem("userId");
}
export function setLoggedInUser(user) {
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("firstTime", user.firstTime);
}
export function getLoggedInUser() {
  const data = localStorage.getItem("user");
  return JSON.parse(data);
}
export function isUserFirstTime() {
  return localStorage.getItem("firstTime");
}
export function setLoggedInUserLevel(userLevel) {
  localStorage.setItem("userLevel", userLevel);
}
export function getLoggedInUserLevel() {
  const stored = parseInt(localStorage.getItem("userLevel"));
  if (stored) return stored;
  const user = getLoggedInUser();
  return user && user.level ? user.level : 0;
}

// ─── Role checks ─────────────────────────────────────────────────────────────

function levelIs(level) {
  return getLoggedInUserLevel() === level;
}

export const isCustomer = () => levelIs(UserLevel.CUSTOMER);
export const isCounterStaff = () => levelIs(UserLevel.COUNTER_STAFF);
export const isAdmin = () => levelIs(UserLevel.ADMIN);
export const isOrderChecker = () => levelIs(UserLevel.ORDER_CHECKER);
export const isBaker = () => levelIs(UserLevel.BAKER);
export const isCashier = () => levelIs(UserLevel.CASHIER);
export const isDelivery = () => levelIs(UserLevel.DELIVERY);
export const isOutletManager = () => levelIs(UserLevel.OUTLET_MANAGER);
export const isWaiter = () => levelIs(UserLevel.WAITER);
export const isSuperAdmin = () => levelIs(UserLevel.SUPER_ADMIN);

// Legacy aliases kept so existing screens don't break
export const isUser = isCustomer;
export const isRetailer = isCounterStaff;
export const isChecker = isOrderChecker;

// ─── Navigation helpers ───────────────────────────────────────────────────────

export function getDefaultPathForLevel() {
  const level = getLoggedInUserLevel();
  return (UserLevelMeta[level] || {}).defaultPath || "/";
}

// ─── User storage ─────────────────────────────────────────────────────────────

export function setUser(user) {
  if (user.token) localStorage.setItem("token", user.token);
  if (user.level) localStorage.setItem("userLevel", user.level);
  if (user.userId) localStorage.setItem("userId", user.userId);
  if (user.isFirstTime) localStorage.setItem("firstTime", user.firstTime);
  localStorage.setItem("user", JSON.stringify(user));
}

export function resetUser() {
  ["token", "userLevel", "firstTime", "user", "userId"].forEach((k) =>
    localStorage.removeItem(k),
  );
}

// ─── Redirects ────────────────────────────────────────────────────────────────

export function authRedirect() {
  resetUser();
  return <Navigate to="/" replace />;
}

export function defaultRedirection(screen) {
  if (!getToken() && getUserId()) {
    return <Navigate to="/verify" replace />;
  }
  if (getToken() && getUserId()) {
    if (screen === "verify" || screen === "login") {
      return <Navigate to={getDefaultPathForLevel()} replace />;
    }
  }
  return null;
}
